import HowMuch from "./HowMuch";

function App() {
  return (
    <div className="App">
      <HowMuch />
    </div>
  );
}

export default App;
